app.controller('PreparationCtrl', function ($scope, $rootScope, $routeParams, uibDateParser, $uibModal, $http, $window, $location, $timeout, Upload, $q, $filter, $translate) {
    $scope.user = {
        AccountType: '',
        Email: '',
        Password: '',
        Handphone: '',
        Sales: '',
        RegistrationInfo: '',
        RegistrationInfoSosmed: '',
        RegistrationInfoOthers: ''
    };

    $scope.showSales = false;
    $scope.disableSales = false;

    if ($routeParams.id) {
        console.log('param', $routeParams.id);
        $scope.user.Sales = $routeParams.id;
        $scope.user.RegistrationInfo = '1';
        $scope.showSales = true;
        $scope.disableSales = true;
    }
    else {
        $scope.showSales = false;
        $scope.disableSales = false;
    }

    $scope.user.PhoneCode = '+62';
    $scope.ConfirmPassword = '';
    $scope.disclaimerRek = false;
    $scope.SalesSelected = '';
    $scope.ListSales = [];

    $scope.page = 'registration';

    $scope.selectSales = function (item, model, label, event) {
        if (item.SalesPersonNID) {
            $scope.user.Sales = item.SalesPersonNID;
            $scope.SalesSelected = item;
        }

    };

    var allPromise = $q.all([
         $http({
             method: 'GET',
             url: '/service/client.svc/GetCountryPhone',
             cache: true,
         }).then(function (data) {
             $scope.ListCountryPhone = data.data.d;
         }, function (error) { }),

         $http({
             method: 'GET',
             url: '/service/client.svc/GetCIFSales',
             cache: true,
         }).then(function (data) {
             $scope.ListSales = data.data.d;
             console.log('listSales', $scope.ListSales);
         }, function (error) { }),
    ]);

    $scope.prepareData = function () {

        //if ($scope.user.AccountType)
        //    $scope.user.AccountType = Number($scope.user.AccountType);

        //if ($scope.user.RegistrationInfo)
        //    $scope.user.RegistrationInfo = Number($scope.user.RegistrationInfo);

        //if ($scope.user.RegistrationInfoSosmed)
        //    $scope.user.RegistrationInfoSosmed = Number($scope.user.RegistrationInfoSosmed);
        //else
        //    $scope.user.RegistrationInfoSosmed = 0;

    }

    $scope.submit = function () {
        $scope.prepareData();
        $translate('VALIDATE.confirmation').then(function (strText) {
            $rootScope.AlertYesNo('question', 'Konfirmasi', strText)
            .then((result) => {
                if (result.value) {
                    $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                    $http({
                        method: 'POST',
                        url: '/service/client.svc/RegistrasiUser',
                        data: {
                            User: $scope.user
                        }
                    }).then(function (data) {
                        console.log('res', data);

                        if (data.data.d.result) {
                            swal('Registration Success', data.data.d.message, 'success').then(function () {
                                $window.location.href = "#/activation/" + $scope.user.Email;
                                $window.location.reload();
                            });
                        }
                        else {
                            swal('Failed', data.data.d.message, 'info');
                        }
                    }, function (error) { });
                }
            });
        });
    }


    allPromise.then(function () {

    });


});



app.controller('FAQCtrl', function ($scope, $rootScope, $routeParams, uibDateParser, $uibModal, $http, $window, $location, $timeout, Upload, $q, $filter, $translate) {

    $scope.showFAQ1 = false;
    $scope.showFAQ2 = false;
    $scope.showFAQ3 = false;
    $scope.showFAQ4 = false;
    $scope.showFAQ5 = false;
    $scope.showFAQ6 = false;

    $scope.chgBackground1 = '';
    $scope.chgBackground2 = '';
    $scope.chgBackground3 = '';
    $scope.chgBackground4 = '';
    $scope.chgBackground5 = '';
    $scope.chgBackground6 = '';

    $scope.showFAQ1Click = function () {
        $scope.showFAQ1 = true;
        $scope.showFAQ2 = false;
        $scope.showFAQ3 = false;
        $scope.showFAQ4 = false;
        $scope.showFAQ5 = false;
        $scope.showFAQ6 = false;

        $scope.chgBackground1 = 'FAQbackground';
        $scope.chgBackground2 = '';
        $scope.chgBackground3 = '';
        $scope.chgBackground4 = '';
        $scope.chgBackground5 = '';
        $scope.chgBackground6 = '';
    }

    $scope.showFAQ2Click = function () {
        $scope.showFAQ1 = false;
        $scope.showFAQ2 = true;
        $scope.showFAQ3 = false;
        $scope.showFAQ4 = false;
        $scope.showFAQ5 = false;
        $scope.showFAQ6 = false;
        
        $scope.chgBackground1 = '';
        $scope.chgBackground2 = 'FAQbackground';
        $scope.chgBackground3 = '';
        $scope.chgBackground4 = '';
        $scope.chgBackground5 = '';
        $scope.chgBackground6 = '';
    }

    $scope.showFAQ3Click = function () {
        $scope.showFAQ1 = false;
        $scope.showFAQ2 = false;
        $scope.showFAQ3 = true;
        $scope.showFAQ4 = false;
        $scope.showFAQ5 = false;
        $scope.showFAQ6 = false;
        
        $scope.chgBackground1 = '';
        $scope.chgBackground2 = '';
        $scope.chgBackground3 = 'FAQbackground';
        $scope.chgBackground4 = '';
        $scope.chgBackground5 = '';
        $scope.chgBackground6 = '';
    }

    $scope.showFAQ4Click = function () {
        $scope.showFAQ1 = false;
        $scope.showFAQ2 = false;
        $scope.showFAQ3 = false;
        $scope.showFAQ4 = true;
        $scope.showFAQ5 = false;
        $scope.showFAQ6 = false;
        
        $scope.chgBackground1 = '';
        $scope.chgBackground2 = '';
        $scope.chgBackground3 = '';
        $scope.chgBackground4 = 'FAQbackground';
        $scope.chgBackground5 = '';
        $scope.chgBackground6 = '';
    }

    $scope.showFAQ5Click = function () {
        $scope.showFAQ1 = false;
        $scope.showFAQ2 = false;
        $scope.showFAQ3 = false;
        $scope.showFAQ4 = false;
        $scope.showFAQ5 = true;
        $scope.showFAQ6 = false;
        
        $scope.chgBackground1 = '';
        $scope.chgBackground2 = '';
        $scope.chgBackground3 = '';
        $scope.chgBackground4 = '';
        $scope.chgBackground5 = 'FAQbackground';
        $scope.chgBackground6 = '';
    }

    $scope.showFAQ6Click = function () {
        $scope.showFAQ1 = false;
        $scope.showFAQ2 = false;
        $scope.showFAQ3 = false;
        $scope.showFAQ4 = false;
        $scope.showFAQ5 = false;
        $scope.showFAQ6 = true;
        
        $scope.chgBackground1 = '';
        $scope.chgBackground2 = '';
        $scope.chgBackground3 = '';
        $scope.chgBackground4 = '';
        $scope.chgBackground5 = '';
        $scope.chgBackground6 = 'FAQbackground';
    }









    var allPromise = $q.all([
         
    ]);

    $scope.prepareData = function () {

    }

    allPromise.then(function () {

    });


});